var React = require('react');

function ArrowsUpdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M15.48 21.5l-4.08 4.1a1.46 1.46 0 01-2.13 0l-4.09-4.1c-1.41-1.4.7-3.53 2.12-2.11l1.48 1.48V6.5c0-2 3-2 3 0v14.45l1.58-1.57c1.41-1.42 3.53.7 2.12 2.12zm8.93-9.83l-1.48-1.48v14.36c0 2-3 2-3 0V10.1l-1.57 1.57c-1.42 1.41-3.54-.7-2.12-2.12l4.08-4.08c.33-.33.7-.47 1.05-.47.36-.01.74.13 1.08.47l4.08 4.08c1.42 1.41-.7 3.53-2.12 2.12z"}));
}

ArrowsUpdown.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ArrowsUpdown;

ArrowsUpdown.default = ArrowsUpdown;
